import { IFixPersonToManager } from "../../../interfaces/store/slices/listAgentSlice";

export const getAttachManagerInnStringInfo = (value: IFixPersonToManager) => {
  if (value?.inn) {
    return `ИНН ${value.inn}`;
  }

  if (value?.organization?.inn) {
    return `ИНН ${value.organization.inn}`;
  }

  return `ИНН`;
};
